import {PlacedBin} from '../placed-bin';
import {PlacementScore} from './placement-score';

export class BinPlacementState {

    constructor(
        public placedBin: PlacedBin,
        public score: PlacementScore
    ) {}

}
